// src/componentes/QRScanner.jsx
import React, { useState } from 'react';
import QrScanner from 'react-qr-scanner';

const QRScanner = () => {
  const [data, setData] = useState(null);

  const handleScan = (result) => {
    if (result) {
      setData(result.text);
      window.location.href = result.text; 
    }
  };

  const handleError = (error) => {
    console.error(error);
  };

  return (
    <div>
      <h1>leer QR</h1>
      <QrScanner
        delay={300}
        onError={handleError}
        onScan={handleScan}
        style={{ width: '160px', height:'160px' }}
      />
      {data && <p>Redirigiendo a: {data}</p>}
    </div>
  );
};

export default QRScanner;
